import { Logo, Input, Button } from '@getinapp/appetizer';
import { Row, Col } from 'react-grid-system';
import { PhoneOutline } from '@styled-icons/evaicons-outline/PhoneOutline';

import { useLoginByEmailHook } from './hooks';
import * as S from './styles';

export const LoginByEmail = () => {
  const {
    isLoginByEmailOpen,
    loading,
    formikProps,
    handleCloseModal,
    handleContinueBySMS,
    handleSubmit,
    t,
  } = useLoginByEmailHook();

  return (
    <S.Modal
      width="15%"
      title={<Logo size="small" />}
      isOpen={isLoginByEmailOpen}
      onRequestClose={handleCloseModal}
    >
      <S.Title>{t('@Login.access-or-create-your-account')}</S.Title>
      <S.Paragraph>{t('@Login.tap-your-email-to-sign-in')}</S.Paragraph>
      <br />
      <form onSubmit={handleSubmit}>
        <Row direction="row" gutterWidth={15} style={{ marginBottom: '1rem' }}>
          <Col>
            <Input {...formikProps('email')} label={t('@Register.email')} />
          </Col>
        </Row>

        <Button isFullWidth loading={loading}>
          {t('@Login.enter')}
        </Button>

        <S.OrText>
          <span />
          {t('@Login.or')}
          <span />
        </S.OrText>

        {/* @ts-ignore */}
        <Button
          type="button"
          isFullWidth
          variant="outline"
          disabled={loading}
          onClick={handleContinueBySMS}
        >
          <PhoneOutline size={20} />
          {t('@Login.access-with-sms')}
        </Button>
      </form>
    </S.Modal>
  );
};
